import React from "react";
import styled from "@emotion/styled";
import {Link} from "react-router-dom";
import {Container} from "views/components/common/container/container.component";
import logo from "assets/img/logo_white.png";
import {HeaderDesktopNav} from "views/components/header/header_desktop_nav.component";

const Root = styled.header`
	padding: 6px 0;
	background-color: var(--primary-maroon);
`;

const LogoWrapper = styled(Link)`
	max-width: 72px;
	margin-left: 14px;

	img {
		width: 100%;
	}
`;

const StyledContainer = styled(Container)`
	max-width: 1440px;
	padding: 0 34px;
`;

export const HeaderDesktop: React.FC = () => {
	return (
		<Root>
			<StyledContainer>
				<LogoWrapper to="/gameplay">
					<img src={logo} loading="lazy" alt="Dr. Pepper" />
				</LogoWrapper>
				<HeaderDesktopNav />
			</StyledContainer>
		</Root>
	);
};
